module.exports = __webpack_public_path__ + "media/images/company/company_02_01-6a2712c06b1fc4203728935b66236c32.jpg";